/*esto fue agregado 16hs 4-12-25 la ultima actualizacion*/
import React, { useState, useEffect } from 'react';
import logo from '../imagenes/logo-inicio.svg'
import './LandingPage.css';

const LandingPage = ({ onEnterApp }) => {
  const [logoLoaded, setLogoLoaded] = useState(false);
  const [logoVisible, setLogoVisible] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [showQuickStart, setShowQuickStart] = useState(false);

  useEffect(() => {
    const loadTimer = setTimeout(() => {
      setLogoLoaded(true);
    }, 300);

    const animateTimer = setTimeout(() => {
      setLogoVisible(true);
    }, 500);

    // Mostrar opción de inicio rápido después de 2 segundos
    const quickStartTimer = setTimeout(() => {
      setShowQuickStart(true);
    }, 2000);

    return () => {
      clearTimeout(loadTimer);
      clearTimeout(animateTimer);
      clearTimeout(quickStartTimer);
    };
  }, []);

  const handleLogoClick = () => {
    setClicked(true);

    setTimeout(() => {
      onEnterApp();
    }, 800);
  };

  const handleQuickStart = () => {
    // Esto activaría el login automático
    // En App.jsx manejaríamos esto diferente
    alert('Use: dante@cafemoctezuma.com / Dantetiana to login');
    handleLogoClick();
  };

  return (
    <div className="landing-page">
      <div className="background-overlay"></div>

      <div className="landing-content">
        <div
          className={`logo-container ${logoLoaded ? 'loaded' : ''} ${logoVisible ? 'visible' : ''} ${clicked ? 'exit' : ''}`}
          onClick={handleLogoClick}
        >
          <div className="coffee-icon">
            <img
              //className='logo'
              src={logo}
              alt='logo'
            /></div>
          {/*<h1 className="app-title">Cafe Motezuma</h1>*/}
        </div>

        <div className="search-examples">
          <a href='www.afromoss.com.ar'>afromoss</a>
        </div>

        {/* Botón de inicio rápido */}
        {showQuickStart && (
          <div className="quick-start-container">
            <p className="quick-start-text">Para Testear:</p>
            <button className="quick-start-btn" onClick={handleQuickStart}>
              Usar Cuenta Demo
            </button>
            <p className="credentials">
              Email: dante@cafemoctezuma.com<br />
              Password: Dantetiana
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default LandingPage;



/*import React, { useState, useEffect } from 'react';
import './LandingPage.css';

const LandingPage = ({ onEnterApp }) => {
  const [logoLoaded, setLogoLoaded] = useState(false);
  const [logoVisible, setLogoVisible] = useState(false);
  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    // Simular carga del logo
    const loadTimer = setTimeout(() => {
      setLogoLoaded(true);
    }, 300);

    // Animar entrada del logo
    const animateTimer = setTimeout(() => {
      setLogoVisible(true);
    }, 500);

    return () => {
      clearTimeout(loadTimer);
      clearTimeout(animateTimer);
    };
  }, []);

  const handleLogoClick = () => {
    setClicked(true);
    
    // Esperar a que termine la animación de salida antes de cambiar de página
    setTimeout(() => {
      onEnterApp();
    }, 800);
  };

  return (
    <div className="landing-page">
      <div className="background-overlay"></div>
      
      <div className="landing-content">
        <div 
          className={`logo-container ${logoLoaded ? 'loaded' : ''} ${logoVisible ? 'visible' : ''} ${clicked ? 'exit' : ''}`}
          onClick={handleLogoClick}
        >
          <div className="coffee-icon">☕</div>
          <h1 className="app-title">Cafe Motezuma</h1>
        </div>

        <div className="search-examples">
          <p>e.g. Shamor  Jujuju  Kita  Canabearo</p>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;*/